import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SupportModal } from './SupportModal';
import { LearnMoreModal } from './LearnMoreModal';
const focusAreas = [{
  title: 'Education & Scholarship',
  description: 'Funding academic research, university chairs, and student fellowships dedicated to the study of Revisionist Zionism and classical liberal nationalism.'
}, {
  title: 'Historical Preservation',
  description: "Digitizing archives, translating Jabotinsky's vast literary and journalistic works into English, and preserving the physical history of the Betar movement."
}, {
  title: 'Modern Policy Research',
  description: "Supporting think tanks and policy institutes that apply Jabotinsky's principles of the Iron Wall and democratic nationalism to contemporary geopolitical challenges."
}];
export function FundSection() {
  const [supportModalOpen, setSupportModalOpen] = useState(false);
  const [learnMoreModalOpen, setLearnMoreModalOpen] = useState(false);
  return <section id="fund" className="py-24 md:py-32 bg-[#EBE5D9]" data-id="element-38">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-39">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-40">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-41">
            <h2 className="text-sm font-medium tracking-[0.2em] text-[#1B2A4A] uppercase mb-4" data-id="element-42">
              The Organization
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-[#1A1A1A] mb-8" data-id="element-43">
              The Jabotinsky Legacy Fund
            </h3>
            <p className="text-lg text-[#1A1A1A]/80 leading-relaxed mb-8" data-id="element-44">
              Our mission is to preserve, translate, and propagate the
              intellectual legacy of Ze'ev Jabotinsky. We believe his synthesis
              of robust national defense and uncompromising classical liberalism
              provides the essential blueprint for a secure, dignified, and
              democratic future.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-45">
              <button onClick={() => setSupportModalOpen(true)} className="inline-flex justify-center items-center px-8 py-4 bg-[#1B2A4A] text-[#F5F0E8] font-medium tracking-wide hover:bg-[#1B2A4A]/90 transition-colors duration-300" data-id="element-46">
                Support the Legacy
              </button>
              <button onClick={() => setLearnMoreModalOpen(true)} className="inline-flex justify-center items-center px-8 py-4 border border-[#1B2A4A] text-[#1B2A4A] font-medium tracking-wide hover:bg-[#1B2A4A]/5 transition-colors duration-300" data-id="element-47">
                Learn More
              </button>
            </div>
          </motion.div>

          <div className="space-y-6" data-id="element-48">
            {focusAreas.map((area, index) => <motion.div key={area.title} initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-[#F5F0E8] p-8 border-l-4 border-[#B8860B] shadow-sm" data-id="element-49">
                <h4 className="text-xl font-serif font-semibold text-[#1A1A1A] mb-3" data-id="element-50">
                  {area.title}
                </h4>
                <p className="text-[#1A1A1A]/70 leading-relaxed" data-id="element-51">
                  {area.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>

      <SupportModal isOpen={supportModalOpen} onClose={() => setSupportModalOpen(false)} data-id="element-52" />

      <LearnMoreModal isOpen={learnMoreModalOpen} onClose={() => setLearnMoreModalOpen(false)} onOpenSupport={() => {
      setLearnMoreModalOpen(false);
      setTimeout(() => setSupportModalOpen(true), 300); // Slight delay for smooth transition
    }} data-id="element-53" />
    </section>;
}